export default __webpack_public_path__ + "static/healthcare-page-hero-img-3ed0feb89e6e28d8c7c1a9a35337eb9d.svg";